// extracted by mini-css-extract-plugin
module.exports = {"container":"read-more-module__container___qVfda","readMore":"read-more-module__readMore___awMNX","readMoreIcon":"read-more-module__readMoreIcon___EQHP-"};